import { render } from "./EventDescription.vue?vue&type=template&id=85516cd2&scoped=true"
import script from "./EventDescription.vue?vue&type=script&lang=js"
export * from "./EventDescription.vue?vue&type=script&lang=js"

import "./EventDescription.vue?vue&type=style&index=0&id=85516cd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85516cd2"]])

export default __exports__